
<div class="cofirm-scores-container">

    <div mat-dialog-content>
        <div class="setup-text-container">
            ADD ACL PLAYER APP TO HOME SCREEN
        </div>
        
        <div class="steps-container">
            <div fxLayout="column" fxLayoutGap="30px" >

                <div fxFlex>
                    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
                        <div fxFlex="initial" class="steps-icons">
                            <img src="/assets/icons/android-click-icon.svg" />
                        </div>

                        <div fxFlex>
                            <div class="step-numbers">
                                Step 1:
                            </div>
                            <div class="step-desc">
                                Click 'Add to home screen' button
                            </div>                        
                        </div>
                    </div>
                </div>

                <mat-divider role="separator" fxflex="none" class="mat-divider divider-full mat-divider-horizontal step-divider" aria-orientation="horizontal"></mat-divider> 

                <div fxFlex>
                    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
                        <div fxFlex="initial" class="steps-icons">
                            <img src="/assets/icons/icon-ios-180x180.png" height="50px" width="50px" />
                        </div>

                        <div fxFlex>
                            <div class="step-numbers">
                                Step 2:
                            </div>
                            <div class="step-desc">
                                Launch ACL Player APP from your home screen
                            </div>                        
                        </div>
                    </div>

                 
                </div>            

                <mat-divider role="separator" fxflex="none" class="mat-divider divider-full mat-divider-horizontal step-divider" aria-orientation="horizontal"></mat-divider>   

            </div>
        </div>

    </div>

    <div mat-dialog-actions style="text-align: right; margin: 0px 10px;">
        <div mat-dialog-actions style="text-align: right;">
            <button mat-raised-button [mat-dialog-close]="false">CANCEL</button>
            <button mat-raised-button [mat-dialog-close]="true" style="background-color: #fc3741;" cdkFocusInitial>ADD TO HOME SCREEN</button>
        </div>
    </div>

</div>









